// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__3WNdH","content":"Item_content__KvsiX","text":"Item_text__GT215","icon":"Item_icon__aWKof","active":"Item_active__24wmA","faded":"Item_faded__3bJGn"};